import { render, staticRenderFns } from "./SubProjectTab.vue?vue&type=template&id=02682bad&"
import script from "./SubProjectTab.vue?vue&type=script&lang=js&"
export * from "./SubProjectTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports